import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { TextInput } from 'src/common/form/text-input';
import debounce from 'lodash/debounce';

interface StepEditorJourneyNameProps {
  value: string;
  errorText?: string;
  onChange: (value: string) => void;
}

export const StepEditorJourneyName = ({ value, errorText, onChange }: StepEditorJourneyNameProps) => {
  const [name, setName] = useState(value);
  const debouncedChangeHandler = useMemo(() => debounce((value) => onChange(value), 500), [onChange]);

  // Stop the invocation of the debounced function after unmounting
  useEffect(() => {
    return () => {
      debouncedChangeHandler.cancel();
    };
  }, [debouncedChangeHandler]);

  const onInputChanged = useCallback(
    (event) => {
      const { value } = event.target;
      debouncedChangeHandler(value);
      setName(value);
    },
    [setName, debouncedChangeHandler]
  );

  return (
    <div className='flex flex-col space-y-sm'>
      <div className='flex flex-col space-y-0.5 text-bedrock-black'>
        <h2 className='text-bedrock-p-strong'>Name this Journey</h2>
        {errorText ? (
          <span className='text-bedrock-p-small text-bedrock-red'>{errorText}</span>
        ) : (
          <span className='text-bedrock-p-small'>Recipients won’t see this name</span>
        )}
      </div>
      <TextInput
        id='journey-name'
        inputClasses='focus:bedrock-text-input-ring'
        onChange={onInputChanged}
        autoFocus
        autoComplete='off'
        required
        inputProps={{ value: name }}
      />
    </div>
  );
};
